import type { WeatherMode } from '../../state/app-state.js';

export class WeatherOverlay {
  private el: HTMLDivElement;
  constructor(parent: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'weather-overlay';
    parent.append(this.el);
  }
  set(mode: WeatherMode): void {
    this.el.classList.remove('weather-rain', 'weather-snow');
    if (mode === 'rainy') this.el.classList.add('weather-rain');
    else if (mode === 'snowing') this.el.classList.add('weather-snow');
  }
}
